module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1002-f161319e458ce1e18b36a376c67f25d0.png";